export default __webpack_public_path__ + "static/media/icons-arrow-left.16e5667a.svg";